/**
 * Formatea gramos para mostrar al usuario.
 * Regla: si es >= 1000g, mostramos en kg con 1-2 decimales.
 * Si es < 1000g, mostramos en g sin decimales.
 */
export const formatGrams = (gr) => {
  if (gr === null || gr === undefined) return '—';
  if (gr === 0) return '0 g';
  if (gr >= 1000) {
    const kg = gr / 1000;
    // 1.5 kg, 12.3 kg, 0.95 kg (cuando hay decimal significativo)
    const formatted = kg >= 10 ? kg.toFixed(1) : kg.toFixed(2).replace(/0$/, '');
    return `${formatted.replace(/\.$/, '')} kg`;
  }
  return `${Math.round(gr)} g`;
};

/**
 * Formatea horas restantes hasta la próxima comida.
 * - >= 1h: "3 h" o "3.5 h"
 * - < 1h: "45 min"
 * - 0: "ahora"
 */
export const formatHours = (hours) => {
  if (hours === null || hours === undefined) return '—';
  if (hours <= 0.05) return 'ahora';
  if (hours < 1) {
    const minutes = Math.round(hours * 60);
    return `${minutes} min`;
  }
  if (hours < 10) {
    return `${hours.toFixed(1).replace(/\.0$/, '')} h`;
  }
  return `${Math.round(hours)} h`;
};

/**
 * Formatea "hace cuánto" desde un timestamp pasado.
 * Útil para mostrar lastFed.
 */
export const formatTimeAgo = (timestampMs, nowMs = Date.now()) => {
  if (!timestampMs) return null;
  const diffMs = Math.max(0, nowMs - timestampMs);
  const diffMin = Math.floor(diffMs / 60_000);

  if (diffMin < 1) return 'hace instantes';
  if (diffMin < 60) return `hace ${diffMin} min`;
  const diffH = Math.floor(diffMin / 60);
  if (diffH < 24) return `hace ${diffH} h`;
  const diffDays = Math.floor(diffH / 24);
  return diffDays === 1 ? 'hace 1 día' : `hace ${diffDays} días`;
};

/**
 * Formatea una lista de strings con coma + "y" final.
 *   ['Luna']                 → 'Luna'
 *   ['Luna', 'Tobi']         → 'Luna y Tobi'
 *   ['Luna', 'Tobi', 'Pepe'] → 'Luna, Tobi y Pepe'
 * Usado por la bitácora para enumerar pets afectadas en eventos de
 * hidratación compartida.
 */
export const formatList = (items) => {
  if (!Array.isArray(items) || items.length === 0) return '';
  if (items.length === 1) return String(items[0]);
  if (items.length === 2) return `${items[0]} y ${items[1]}`;
  const head = items.slice(0, -1).join(', ');
  const tail = items[items.length - 1];
  return `${head} y ${tail}`;
};